import {
  BNBox,
  BNInlineSvgIcon,
  BNInlineSvgIconProps,
  BNJumpToNavigation,
  BNLogo,
  BNStack,
  getRouteAction,
  OtherLanguage,
} from "@bn-monorepo/js-packages";
import { useTheme } from "@mui/material";
import { useContext } from "react";
import { SettingsContext } from "../../settingsContext";
import BNLink from "../BnComponents/BNLink/BNLink";
import HeaderButton from "@bn-monorepo/js-packages/src/Components/BNHeader/HeaderButton";
import { BNHeaderMegaMenuMobile } from "./MegaMenu/BNHeaderMegaMenuMobile";
import { BNHeaderMegaMenuDesktop } from "./MegaMenu/BNHeaderMegaMenuDesktop";

import { HeaderCms } from "../CmsContent/services";
import { LanguageOutlined } from "@mui/icons-material";
export interface Props {
  isSticky: boolean;
  header: HeaderCms;
  otherLanguage?: OtherLanguage;
}

export const BNHeaderWithMegaMenu: React.FC<Props> = ({ isSticky, header, otherLanguage }) => {
  const theme = useTheme();
  const { localization, env } = useContext(SettingsContext);

  const { megaMenu, menuOpenLabel, homeLink } = header;
  const { list, headerButtons } = megaMenu;

  const iconButtonSx = [
    { color: "tertiary.main" },
    theme.applyStyles("dark", {
      color: "white",
    }),
  ];
  const stickySx = isSticky
    ? {
        position: "sticky",
        top: "0",
        zIndex: 2,
      }
    : {};
  const maxWidthDesktop = "120rem";
  const maxWidthMobile = "60rem";
  return (
    <>
      <BNJumpToNavigation jumpToNavigationString={localization?.jumpToNavigation} />
      <BNBox
        sx={[
          {
            ...stickySx,
            backgroundColor: "background.default",
            color: "white",
            px: 2,
            height: "6rem",
            borderBottom: `0.1rem solid ${theme.vars.palette.secondary.light}`,
          },
          theme.applyStyles("dark", {
            background: "linear-gradient(to bottom, rgba(32, 36, 39, 0.85) 90%, rgba(32, 36, 39, 0.75))",
            backdropFilter: "blur(2rem)",
            WebkitBackdropFilter: "blur(2rem)",
            "&::after": {
              content: '""',
              position: "absolute",
              left: 0,
              right: 0,
              bottom: 0,
              height: "3rem",
              transform: "translateY(100%)",
              background: "linear-gradient(to bottom, rgba(32, 36, 39, 0.5), transparent)",
              pointerEvents: "none",
            },
          }),
        ]}
      >
        <BNStack
          component={"header"}
          direction={"row"}
          sx={{
            mx: "auto",
            maxWidth: { xs: maxWidthMobile, md: maxWidthDesktop },
            justifyContent: "space-between",
            maxHeight: "6rem",
          }}
          data-uit-container="header"
        >
          <BNHeaderMegaMenuMobile
            list={list}
            menuOpenLabel={menuOpenLabel}
            sx={{
              [theme.breakpoints.up("md")]: {
                display: "none",
              },
            }}
          />
          <BNBox
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <BNLink href={homeLink} isSpa={true}>
              <BNLogo dark={true} sx={{ maxWidth: { xs: "16rem", md: "100%" } }} />
            </BNLink>
          </BNBox>
          <BNHeaderMegaMenuDesktop
            list={list}
            sx={{
              [theme.breakpoints.down("md")]: {
                display: "none",
              },
            }}
          />
          <BNStack direction={"row"} data-uit="header-buttons" sx={{ gap: 1 }}>
            {otherLanguage && (
              <>
                <HeaderButton
                  dataUit="switch-language"
                  link={otherLanguage.url}
                  hrefLang={otherLanguage.languageCode}
                  icon={LanguageOutlined}
                  iconButtonSx={[
                    {
                      px: 0,
                    },
                    ...iconButtonSx,
                  ]}
                  text={otherLanguage.label}
                />
              </>
            )}
            {headerButtons.map((x) => (
              <HeaderButton
                key={x.link.url}
                text={x.link.name}
                icon={BNInlineSvgIcon}
                iconProps={
                  {
                    svgString: x.iconInlineSvg,
                    noStroke: true,
                  } as BNInlineSvgIconProps
                }
                hidden={{
                  mdDown: x.hidden.mobile,
                  mdUp: x.hidden.desktop,
                }}
                iconButtonSx={[
                  {
                    px: 0,
                  },
                  ...iconButtonSx,
                ]}
                link={x.link.url}
                dataUit={getRouteAction(x.link.url)}
                dataCmsTargetKey={env !== "prod" ? x.link.udi : undefined}
                clickHandlerOverride={null}
              />
            ))}
          </BNStack>
        </BNStack>
      </BNBox>
    </>
  );
};
